import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`



// WEBPACK FOOTER //
// ./src/components/HeaderSidebarLayout/Wrapper.js